import React, { useState, useEffect } from 'react';
import { Container, Grid, Typography, Box, Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import logo from '../Fxer.AI (7).png'; // Replace with the actual path to your logo image
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate from react-router-dom

const SubscriptionNeededPage: React.FC = () => {
    const { getAccessTokenSilently } = useAuth0();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const baseUrl = 'http://localhost:3000';
    //const baseUrl = 'https://fxer.network';

    const navigate = useNavigate(); // Initialize useNavigate

    useEffect(() => {
        const checkSubscription = async () => {
            try {
                const token = await getAccessTokenSilently();
                const response = await fetch(`${baseUrl}/user/subscription`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
                
                if (!response.ok) {
                    throw new Error('Failed to fetch subscription status');
                }

                const data = await response.json();
                if (data.active) {
                    navigate('/'); // Redirect to home if subscription is active
                }
            } catch (err) {
                console.error(err);
                setError('An error occurred while checking subscription status.');
            }
        };

        checkSubscription();
    }, [getAccessTokenSilently, navigate]);

    const handleCheckout = async () => {
        setLoading(true);
        setError(null);

        try {
            const token = await getAccessTokenSilently();
            const response = await fetch(`${baseUrl}/user/subscription`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (!response.ok) {
                throw new Error('Failed to create subscription session');
            }

            const data = await response.json();
            if (data.url) {
                window.location.href = data.url;
            } else {
                setError('Failed to get the subscription URL');
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
            setError('An error occurred while processing your request. Please try again.');
            setLoading(false);
        }
    };

    return (
        <Container maxWidth={false} sx={{ minHeight: '100vh', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', paddingTop: 0 }}>
            <Grid 
                container 
                spacing={4} 
                alignItems="flex-start" 
                sx={{ 
                    width: { xs: '100%', md: '80%' }, 
                    margin: 0, 
                    paddingLeft: { xs: '0', md: '240px' },
                    '& .MuiGrid-item': { 
                        paddingLeft: '0 !important', 
                        paddingRight: '0 !important', 
                        margin: '0 !important' 
                    }
                }}
            >
                <Grid item xs={12} md={6} sx={{ textAlign: { xs: 'center', md: 'left' }, padding: 0 }}>
                    <Box component="img" src={logo} alt="Logo" sx={{ height: 100, marginBottom: 2 }} />
                    <Typography variant="h4" sx={{ color: '#131E3A', marginBottom: 2 }}>
                        Subscribe Now
                    </Typography>
{/*                     <Typography variant="body1" sx={{ color: '#131E3A', marginBottom: 2 }}>
                        Fix your household issues fast and affordably.
                    </Typography> */}
                    <Typography variant="body1" sx={{ color: '#131E3A', marginBottom: 2 }}>
                        Gain invaluable insights into your house!
                    </Typography>
                    <Typography variant="body1" sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                        <CheckCircleIcon sx={{ color: 'green', marginRight: 1 }} />
                        Free for the first month
                    </Typography>
                    <Typography variant="body1" sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                        <CheckCircleIcon sx={{ color: 'green', marginRight: 1 }} />
                        Less than a cup of coffee a month
                    </Typography>
                    <Typography variant="body1" sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                        <CheckCircleIcon sx={{ color: 'green', marginRight: 1 }} />
                        Save hundreds on service calls
                    </Typography>
                    <Typography variant="body1" sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                        <CheckCircleIcon sx={{ color: 'green', marginRight: 1 }} />
                        Instant access to indepth analysis
                    </Typography>
                </Grid>
                <Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 0 }}>
                    <Box sx={{ width: '100%', textAlign: 'center', marginTop: { xs: 0, md: '20%' } }}>
                        <Button
                            variant="contained"
                            color="primary"
                            fullWidth
                            sx={{ marginBottom: 2 }}
                            onClick={handleCheckout}
                            disabled={loading} // Disable the button when loading
                        >
                            Subscribe Now
                        </Button>
                        {error && (
                            <Typography variant="body1" sx={{ color: 'red', marginTop: 2 }}>
                                {error}
                            </Typography>
                        )}
                    </Box>
                </Grid>
            </Grid>
        </Container>
    );
};

export default SubscriptionNeededPage;
